import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/features/AppHeader";
import AppMenu from "../components/features/Menu";
import "./index.scss";
const MainLayout = ({}) => {
  return (
    <div translate="no">
      <Header />
      <div className="wapperLayout" style={{ display: "flex" }}>
        <AppMenu />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
